// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cSzx","rootNoMargin":"styles_rootNoMargin__3pOQO"};